import { sntTranslate } from "src/app/support/translate";
import { marker } from "@jsverse/transloco-keys-manager/marker";
import { Invoice, InvoiceLight } from "src/app/backend/models/invoice/invoice";
import { dateUtil } from "src/app/support/date-util";

export async function getPaymentTerms(): Promise<
  Array<{ display: string; value: string }>
> {
  return [
    {
      value: "30",
      display: sntTranslate(marker("+30 giorni"))
    },
    {
      value: "60",
      display: sntTranslate(marker("+60 giorni"))
    },
    {
      value: "90",
      display: sntTranslate(marker("+90 giorni"))
    },
    {
      value: "120",
      display: sntTranslate(marker("+120 giorni"))
    }
  ];
}

export function getInvoiceName({
  invoice,
  omitDate,
  omitFileExtension,
  short
}: {
  invoice: InvoiceLight;
  omitDate?: boolean;
  omitFileExtension?: boolean;
  short?: boolean;
}): string {
  return getInvoiceFileName(invoice, omitDate, omitFileExtension);
}

export function getPaymentReceiptFileName(invoice: InvoiceLight): string {
  return `${sntTranslate(marker("Ricevuta di pagamento"))} - ${getInvoiceFileName(invoice, false, true)}.pdf`;
}

export function getInvoiceFileName(
  invoice: InvoiceLight,
  omitDate: boolean = false,
  omitFileExtension: boolean = false,
  short: boolean = false
): string {
  let text = "";

  if (invoice.isDraft) {
    text = `${sntTranslate(marker("Notula"))}`;
  } else {
    text = `${sntTranslate(short ? marker("FT.") : marker("Fattura n."))} ${invoice.number}`;
  }

  const date = invoice.emittedAt || invoice.createdAt || undefined;

  if (date && !omitDate) {
    text = `${text} ${sntTranslate(marker("del"))} ${dateUtil(date).format(
      "DD/MM/YYYY"
    )}`;
  }

  return omitFileExtension ? text : `${text}.pdf`;
}

/**
 * Hash FNV-1a: ultra-veloce, sincrono e leggero.
 * Trasforma una stringa in un intero a 32 bit.
 */
function fnv1a(str: string): number {
  let hash = 0x811c9dc5;
  for (let i = 0; i < str.length; i++) {
    hash ^= str.charCodeAt(i);
    hash +=
      (hash << 1) + (hash << 4) + (hash << 7) + (hash << 8) + (hash << 24);
  }

  return hash >>> 0;
}

/**
 * Genera il codice Notula in modo sincrono (formato: 123-456).
 */
export function generateReadableNotulaIdSync(
  notulaId: string,
  clientId: string
): string {
  const numericValue = fnv1a(`${notulaId}-${clientId}`);
  const pinNumber = numericValue % 1000000;
  const pinString = pinNumber.toString().padStart(6, "0");

  return `${pinString.slice(0, 3)}-${pinString.slice(3)}`;
}
